import { Account } from '@/client/accounts';

export type SendingProfileMeta = {
  cloneOf?: string;
  sourceCampaignId?: string;
};

export type SendingProfile = {
  id: string;
  name: string;
  type: SendingProfileType;
  senderName: string;
  fromAddress: string;
  interfaceType: string;
  host: string;
  username: string;
  password: string;
  ignoreCertErrors: boolean;
  created: Date;
  updated: Date;
  account: Account;
  meta?: SendingProfileMeta;
};

export enum SendingProfileType {
  CONNECTOR = 'connector',
  HEYSENDER = 'heysender',
}
